import { ComponentPublicInstance, h, VNode } from 'vue';

import { createApp } from './app.ts';
import DialogConfirm from './components/DialogConfirm.vue';

export type ModalInstance = ComponentPublicInstance & { close: () => void };

export let openModals = 0;

function syncModalClass(): void {
    document.body.classList.toggle('modal-open', openModals > 0);
}

export function modal(render: () => VNode) {
    let closed = false;

    const app = createApp({
        render() {
            const content = render();
            const close = content.props?.onClose;
            content.props = {
                ...content.props,
                onClose: () => {
                    if (closed) {
                        return;
                    }

                    closed = true;
                    close?.();
                    openModals--;
                    syncModalClass();
                    setTimeout(
                        () => app.unmount(),
                        parseFloat(getComputedStyle(this.$el).transitionDuration) * 1000,
                    );
                },
            };
            return content;
        },
        methods: {
            close() {
                this.$el.close();
            },
        },
    });

    const instance = app.mount(document.createElement('div'));

    document.body.appendChild(instance.$el);
    openModals++;
    syncModalClass();

    return instance as ModalInstance;
}

export function confirmDialog(props: any) {
    return new Promise<boolean>((resolve) => {
        let confirmed = false;

        modal(() =>
            h(DialogConfirm, {
                ...props,
                onConfirm: async () => {
                    await props.onConfirm?.();
                    confirmed = true;
                    resolve(true);
                },
                onClose: () => {
                    if (!confirmed) {
                        resolve(false);
                    }
                },
            }),
        );
    });
}

export async function requireConfirmation(props: any) {
    if (await confirmDialog(props)) {
        return;
    }

    const cancelled = new Promise(() => {});
    return cancelled;
}
